import * as React from "react"

import Suggestion from "./Suggestion"
import { ISuggestion } from "../../../index"

interface OwnProps {
    focusedSuggestionCode: string | null
    onSuggestionClick: (selectedSuggestion: ISuggestion) => void
    suggestions: ISuggestion[]
}

export const SuggestionList = ({
    focusedSuggestionCode,
    onSuggestionClick,
    suggestions,
}: OwnProps): JSX.Element => (
    <>
        {suggestions.map((suggestion, index) => (
            <Suggestion
                highlighted={suggestion.normalized === focusedSuggestionCode}
                suggestion={suggestion}
                key={index}
                onSuggestionClick={onSuggestionClick}
            />
        ))}
    </>
)
